import classNames from 'classnames'
import React, {memo, useMemo} from 'react'

import type {GroupDescriptionItem} from '../../Parameters.types'
import {ParameterGroup} from '../../Parameters.types'

import {ConfigurationDescription} from './ConfigurationDescription/ConfigurationDescription'
import {EnviromentDescription} from './EnviromentDescription/EnviromentDescription'
import {SystemDescription} from './SystemDescription/SystemDescription'

import styles from './ParametersGroupDescription.css'

interface Props {
  item: GroupDescriptionItem

  className?: string
}

function ParametersGroupDescriptionComponent(props: Props) {
  const content = useMemo(() => {
    switch (props.item.group) {
      case ParameterGroup.CONFIGURATION:
        return <ConfigurationDescription />
      case ParameterGroup.SYSTEM:
        return <SystemDescription />
      case ParameterGroup.ENVIRONMENT:
        return <EnviromentDescription />
      default:
        return null
    }
  }, [props.item.group])

  return (
    <div role="cell" className={classNames(styles.groupDescription, props.className)}>
      {content}
    </div>
  )
}

export const ParametersGroupDescription = memo<Props>(ParametersGroupDescriptionComponent)
